import { type LayoutType, DEFAULT_LAYOUT, LAYOUTS_MAP } from './layoutsMap'

export function useLayout() {
  const route = useRoute()
  return computed(() => {
    const layoutKey = (route.meta.layout as LayoutType) || DEFAULT_LAYOUT
    return LAYOUTS_MAP[layoutKey] || LAYOUTS_MAP[DEFAULT_LAYOUT]
  })
}
